module.exports = __webpack_public_path__ + "static/media/studio-etc16.623e5f25.png";